const { createDate, vehicleReqDate, routeShortForm, routeDetails } = require('../../utils');

module.exports = [
  {
    id: 1,
    key: 'indent_id',
    label: 'INDENT ID',
    tlabel: 'INDENT_INDENT_ID',
    css_class: 'order-id',
    data: {
      key: 'order_number',
    },
    truncate_on: 20,
    dependency: {
      is_enabled: true,
      css_class: 'test',
      data: {
        key: 'created_at',
        view_rule: date => createDate(date),
      },
      truncate_on: 20,
    },
    sort_by: true,
  },
  {
    id: 2,
    label: 'STATUS',
    tlabel: 'INDENT_STATUS',
    css_class: 'order-status',
    data: {
      key: 'status',
    },
    truncate_on: 20,
  },
  {
    id: 3,
    label: 'ROUTE',
    tlabel: 'INDENT_ROUTE',
    css_class: 'order-route',
    data: {
      key: 'route_location',
      view_rule: routeLocation => routeShortForm(routeLocation),
    },
    expanded_text: {
      data: {
        key: 'route_location',
        view_rule: routeLocation => routeDetails(routeLocation),
      },
    },
    truncate_on: 20,
  },
  {
    id: 4,
    label: 'TRANSPORTER',
    tlabel: 'INDENT_TRANSPORTER',
    css_class: 'order-vendor',
    data: {
      key: 'transporter_name',
    },
    truncate_on: 16,
  },
  {
    id: 5,
    label: 'VEHICLE TYPE',
    tlabel: 'INDENT_VEHICLE_TYPE',
    css_class: 'order-truck',
    data: {
      key: 'vehicle_type_name',
    },
    truncate_on: 20,
    dependency: {
      is_enabled: true,
      css_class: 'test',
      data: {
        key: 'sources',
        view_rule: (sources, format = 'DD MMM YYYY | hh:mm A') => vehicleReqDate(sources, format),
      },
      truncate_on: 24,
    },
  },
];
